import {Col} from "react-bootstrap"
import React from "react"
import PropTypes from "prop-types"

import {injectIntl, FormattedMessage} from "@irati/utils/lang"
import id from "@irati/utils/id"
import {RouterLink} from "@irati/ui/src/Link"

import searchNothingFound from "@irati/ui/images/search_nothing_found.svg"
import {Body, H4} from "@irati/ui/src/Typography"
import Img from "./styled/Img"
import RowMargin from "./styled/RowMargin"

const EmptyState = (props, {apps, appPath}) => {
  const {onHide} = props
  const idNamespace = id("empty-state", props)
  const isRewards = appPath === apps.FLEXIREWARDS
  const app = isRewards ? apps.FLEXIREWARDS : apps.PERKS
  const linkLabel = isRewards
    ? "perks.components.searchPopup.noResults.linkToRewards"
    : "perks.components.searchPopup.noResults.linkToPerks"
  const link = (
    <RouterLink id={id("link", idNamespace)} to="/" onClick={onHide} app={app}>
      {props.formatMessage({id: linkLabel})}
    </RouterLink>
  )

  return (
    <RowMargin id={idNamespace}>
      <Col sm={2} md={1}>
        <Img
          id={id("image", idNamespace)}
          src={searchNothingFound}
          alt={props.formatMessage({id: "perks.components.searchPopup.noResults.imageAlt.nothingFound"})} />
      </Col>
      <Col sm={10} md={11}>
        <H4 id={id("title", idNamespace)} data-test="empty-header">
          <FormattedMessage id="perks.components.searchPopup.noResults.heading" />
        </H4>
        <Body id={id("copy", idNamespace)}>
          <FormattedMessage id="perks.components.searchPopup.noResults.description" values={{link}} />
        </Body>
      </Col>
    </RowMargin>
  )
}

EmptyState.propTypes = {
  onHide: PropTypes.func.isRequired,
  formatMessage: PropTypes.func
}

EmptyState.contextTypes = {
  apps: PropTypes.object.isRequired,
  appPath: PropTypes.string.isRequired
}

export default injectIntl(EmptyState)
